import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "list-group" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "badge bg-secondary"
}
const _hoisted_6 = {
  key: 1,
  class: "badge bg-warning"
}
const _hoisted_7 = {
  key: 2,
  class: "badge bg-warning"
}
const _hoisted_8 = {
  key: 3,
  class: "badge bg-danger"
}
const _hoisted_9 = {
  key: 4,
  class: "badge bg-dark"
}
const _hoisted_10 = {
  key: 5,
  class: "progress"
}
const _hoisted_11 = {
  key: 1,
  class: "list-group-item"
}



export default /*#__PURE__*/_defineComponent({
  name: 'player-content.component',
  props: {
  cMonitor: Array,
},
  setup(__props) {



const WAITING = 101;
const STARTED = 102;
const DEFAULT = 103;
const ERROR = 201;
const DEPRECATED = 301;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (__props.cMonitor.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.cMonitor, (state) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "list-group-item",
            key: state.id
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(state.id), 1),
              _createElementVNode("div", _hoisted_4, [
                (state.code === WAITING)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Waiting"))
                  : (state.code === STARTED)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Started"))
                    : (state.code === DEFAULT)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "In the Default Pool"))
                      : (state.code === ERROR)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Error"))
                        : (state.code === DEPRECATED)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Deprecated"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", {
                                class: "progress-bar bg-success",
                                role: "progressbar",
                                style: _normalizeStyle({ width: state.code + '%' }),
                                "aria-valuenow": "{{state.code}}",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }, _toDisplayString(state.code) + "% ", 5)
                            ]))
              ])
            ])
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock("li", _hoisted_11, "No data"))
  ]))
}
}

})